// import Constants from '../constants'

// const b = Constants.banner

export default {

}
